var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleLoginArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 255.277,
    height: 346.277,
    viewBox: "0 0 255.277 346.277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -43.357,
    y1: -15.387,
    x2: -44.097,
    y2: -12.924,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -34.077,
    y1: 0.133,
    x2: -34.475,
    y2: 0.802,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.168,
    y1: -0.385,
    x2: 0.385,
    y2: 0.421,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.303,
    y1: -0.801,
    x2: 0.764,
    y2: 1.159,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -14.012,
    y1: -0.363,
    x2: -13.603,
    y2: 0.753,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23484",
    "data-name": "Group 23484",
    transform: "translate(-1447.219 -494.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23480",
    "data-name": "Group 23480",
    transform: "translate(1447.219 494.271)",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3971",
    "data-name": "Path 3971",
    d: "M903.016,438.4a38.452,38.452,0,1,1,76.657-6.166v0a41.179,41.179,0,0,0,16.345,29.644,48.923,48.923,0,0,1,19.475,35.313v0a45.981,45.981,0,0,0,20.848,34.9,55.69,55.69,0,1,1-85.754,51.227q-.2-2.459-.181-4.882a57.446,57.446,0,0,0-17.744-41.889,49.119,49.119,0,0,1-13.669-47.374,32.194,32.194,0,0,0-6.827-28.822A38.263,38.263,0,0,1,903.016,438.4Z",
    transform: "translate(-900.972 -322.052)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3975",
    "data-name": "Path 3975",
    d: "M1035.082,623.814a.777.777,0,0,0,.638-1.219c-62.676-90.54-87.014-174.438-87.252-175.275a.777.777,0,0,0-1.494.426c.239.839,24.649,84.983,87.47,175.733A.777.777,0,0,0,1035.082,623.814Z",
    transform: "translate(-909.245 -333.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3983",
    "data-name": "Path 3983",
    d: "M1027.272,482.09a.772.772,0,0,0,.51-.191c8.805-7.663,13.424-31.758,13.616-32.779a.776.776,0,1,0-1.525-.287c-.047.245-4.711,24.585-13.11,31.895a.776.776,0,0,0,.509,1.362Z",
    transform: "translate(-976.573 -333.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3985",
    "data-name": "Path 3985",
    d: "M1071.869,487.586a.776.776,0,0,0,.2-1.525c-.161-.045-16.177-4.519-26.107-13.339a.777.777,0,0,0-1.031,1.161c10.206,9.064,26.057,13.491,26.727,13.675A.8.8,0,0,0,1071.869,487.586Z",
    transform: "translate(-1021.922 -338.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M996.847,548.709a.772.772,0,0,0,.6-.284c11.937-14.508,13.7-38.537,13.721-38.778a.776.776,0,1,0-1.549-.106c-.017.237-1.753,23.779-13.37,37.9a.777.777,0,0,0,.6,1.27Z",
    transform: "translate(-922.707 -347.071)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3982",
    "data-name": "Path 3982",
    d: "M1050.046,556.177c.482,0,.775-.014.856-.02a.776.776,0,0,0-.089-1.55c-.17.006-17.371.793-35.632-14.129a.777.777,0,1,0-.983,1.2C1030.837,555.278,1046.266,556.177,1050.046,556.177Z",
    transform: "translate(-977.024 -354.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3976",
    "data-name": "Path 3976",
    d: "M1006.851,637.808c1.492,0,2.352-.063,2.393-.066a.777.777,0,0,0-.123-1.549c-.2.015-20.388,1.471-37.6-10.543a.776.776,0,1,0-.888,1.273C984.78,636.8,1000.877,637.808,1006.851,637.808Z",
    transform: "translate(-901.481 -373.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3977",
    "data-name": "Path 3977",
    d: "M953.589,629.894a.776.776,0,0,0,.557-.236c.507-.523,12.435-13.08,13.153-37.254a.776.776,0,1,0-1.551-.046c-.7,23.536-12.6,36.1-12.717,36.219a.777.777,0,0,0,.558,1.317Z",
    transform: "translate(-845.245 -365.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3969",
    "data-name": "Path 3969",
    d: "M865.8,315.4a49.27,49.27,0,1,0-70.556,68.79l0,0a52.768,52.768,0,0,1,14.835,40.759,62.684,62.684,0,0,0,17.669,48.557l0,0a58.915,58.915,0,0,1,16.117,49.537,71.356,71.356,0,1,0,121.713-39.592q-2.207-2.263-4.56-4.289A73.606,73.606,0,0,1,935.55,426.74a62.935,62.935,0,0,0-34.2-53.118,41.249,41.249,0,0,1-22.063-30.88A49.042,49.042,0,0,0,865.8,315.4Z",
    transform: "translate(-730.571 -300.523)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3970",
    "data-name": "Path 3970",
    d: "M950.112,595.549a.811.811,0,0,0,.191-.023.778.778,0,0,0,.563-.943C916.231,457.5,855.612,363.062,855,362.124a.776.776,0,1,0-1.3.845c.607.936,61.091,95.179,95.659,231.994A.778.778,0,0,0,950.112,595.549Z",
    transform: "translate(-751.775 -314.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3978",
    "data-name": "Path 3978",
    d: "M989.127,410.871a20.555,20.555,0,0,0,2.807-.182.776.776,0,1,0-.211-1.538c-14.21,1.95-41.7-14.093-41.973-14.255a.777.777,0,0,0-.787,1.339,167.617,167.617,0,0,0,15.828,7.976C974.919,408.638,983.085,410.871,989.127,410.871Z",
    transform: "translate(-867.263 -321.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3979",
    "data-name": "Path 3979",
    d: "M936.578,403.344a.777.777,0,0,0,.7-.439c.095-.2,9.451-19.787,9.305-37.224a.776.776,0,0,0-.777-.77H945.8a.778.778,0,0,0-.771.783c.143,17.078-9.057,36.343-9.15,36.535a.776.776,0,0,0,.7,1.113Z",
    transform: "translate(-811.32 -314.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3972",
    "data-name": "Path 3972",
    d: "M957.253,496.031a.777.777,0,0,0,.022-1.553c-23.49-.69-47.729-18.9-47.97-19.079a.776.776,0,1,0-.94,1.236c.246.187,24.872,18.691,48.864,19.4Z",
    transform: "translate(-801.222 -339.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3973",
    "data-name": "Path 3973",
    d: "M886.509,488.117a.771.771,0,0,0,.554-.233c.159-.162,15.888-16.54,16.9-47.48a.776.776,0,0,0-.751-.8h-.025a.777.777,0,0,0-.776.751,81.914,81.914,0,0,1-8.6,34.71,52.416,52.416,0,0,1-7.855,11.732.777.777,0,0,0,.555,1.32Z",
    transform: "translate(-729.818 -331.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3974",
    "data-name": "Path 3974",
    d: "M838.924,598.43a.776.776,0,0,0,.542-.221c.189-.185,19.054-18.861,22.037-46.254a.777.777,0,0,0-1.544-.168c-2.922,26.845-21.391,45.128-21.577,45.31a.777.777,0,0,0,.543,1.333Z",
    transform: "translate(-650.412 -356.521)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M913.8,606.8c.4,0,.624-.01.645-.01a.777.777,0,0,0-.082-1.551c-.22.014-22.444.92-45.825-18.3a.777.777,0,0,0-.986,1.2C889.178,605.917,909.92,606.8,913.8,606.8Z",
    transform: "translate(-726.697 -364.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3986",
    "data-name": "Path 3986",
    d: "M1022.558,712.1H800.178V667.589h222.38C1017.8,667.589,1017.8,712.1,1022.558,712.1Z",
    transform: "translate(-781.977 -382.56)",
    fill: "#eeeef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3984",
    "data-name": "Path 3984",
    d: "M809.647,698.064v-20.37c0-7.18,4.394-13,9.815-13h211.627a7.72,7.72,0,0,0,7.719-7.719h0a2.345,2.345,0,0,0-2.345-2.345H805.171c-5.3,0-13.726,8.34-13.726,18.627V701.7c0,9.7,8.176,17.563,13.177,17.563h230.625a3.562,3.562,0,0,0,3.562-3.562h0a6.5,6.5,0,0,0-6.5-6.5H818.055C813.411,709.2,809.647,704.214,809.647,698.064Z",
    transform: "translate(-791.445 -379.664)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3987",
    "data-name": "Path 3987",
    d: "M809.872,679.9h208.512a.776.776,0,1,0,0-1.553H809.872a.776.776,0,1,0,0,1.553Z",
    transform: "translate(-785.503 -384.965)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3988",
    "data-name": "Path 3988",
    d: "M809.872,688.41h208.512a.777.777,0,0,0,0-1.553H809.872a.777.777,0,0,0,0,1.553Z",
    transform: "translate(-785.503 -386.864)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3989",
    "data-name": "Path 3989",
    d: "M809.872,696.918h208.512a.777.777,0,0,0,0-1.553H809.872a.777.777,0,0,0,0,1.553Z",
    transform: "translate(-785.503 -388.766)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3990",
    "data-name": "Path 3990",
    d: "M809.872,705.426h208.512a.777.777,0,0,0,0-1.553H809.872a.777.777,0,0,0,0,1.553Z",
    transform: "translate(-785.503 -390.667)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3991",
    "data-name": "Path 3991",
    d: "M809.872,713.934h208.512a.777.777,0,0,0,0-1.553H809.872a.777.777,0,0,0,0,1.553Z",
    transform: "translate(-785.503 -392.569)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23406",
    "data-name": "Group 23406",
    transform: "translate(18.516 226.463)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7986",
    "data-name": "Rectangle 7986",
    width: 200.1,
    height: 48.301,
    rx: 20.095,
    transform: "translate(0 0)",
    fill: "#afd75f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7987",
    "data-name": "Rectangle 7987",
    width: 23.507,
    height: 37.199,
    rx: 7.242,
    transform: "translate(22.614 5.551)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7988",
    "data-name": "Rectangle 7988",
    width: 8.82,
    height: 37.199,
    rx: 3.67,
    transform: "translate(49.579 5.551)",
    fill: "#fff",
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23405",
    "data-name": "Group 23405",
    transform: "translate(91.82 211.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11927",
    "data-name": "Group 11927",
    transform: "translate(0 45.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3895",
    "data-name": "Path 3895",
    d: "M957.7,699.2s-27.158,39.272-55.681,27.972c-22.923-9.081,7.816-9.986,32.794-19.02a1.633,1.633,0,0,0-.98-3.113c-19.773,5.334-50.2,11.582-56.919,1.794-10.151-14.776-1.662-10.672,23.149-11.63s28.731-7.635,12.235-9.285-40.84,10.056-47.8,3.09-12.234-21.925-15.473-28.23,28.315-20.588,38.352-13.077,19.822,25.946,30.837,28.089-2.6-13.507-10.768-21.433-11.811-14.14,2.442-13.879,23.9,16.337,27.057,28.872,9.024,19,7.967,12.735-5.9-25.28-11.135-30.5S961.367,649.237,957.7,699.2Z",
    transform: "translate(-848.798 -640.469)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3896",
    "data-name": "Path 3896",
    d: "M931.942,707.613a.42.42,0,0,1-.434-.02c-30.459-20.265-78.54-31.558-79.022-31.67a.422.422,0,0,1,.19-.822c.484.112,48.711,11.439,79.3,31.79a.422.422,0,0,1,.117.585A.417.417,0,0,1,931.942,707.613Z",
    transform: "translate(-825.584 -648.206)",
    fill: "#fff",
    opacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11928",
    "data-name": "Group 11928",
    transform: "translate(56.955 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M859.8,703.989s-57.824,9.608-72.228-25.19c-11.577-27.967,15.481-1.641,44.784,12.662a2.006,2.006,0,0,0,1.907-3.525c-21.6-12.875-53.093-34.356-50.208-48.646,4.355-21.572,7.99-10.583,30.03,10.473s31.276,18.807,18.637,2.854-43.756-27.414-43.556-39.5,8.878-29.516,11.669-37.758,42.34,7.374,44.293,22.639-5.94,39.64,1.58,51.182,9.686-13.832,9.7-27.8,2.375-22.492,14.322-9.7,6.014,35.025-2.338,48.519-9.044,24.19-4.421,17.9,17.246-26.8,17.371-35.87S906.979,664.539,859.8,703.989Z",
    transform: "translate(-783.87 -573.083)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M863.34,711.342a.516.516,0,0,1-.353-.4c-8.156-44.166-39.275-96.2-39.588-96.721a.517.517,0,1,1,.887-.534c.315.521,31.53,52.715,39.72,97.068a.518.518,0,0,1-.415.6A.509.509,0,0,1,863.34,711.342Z",
    transform: "translate(-790.181 -582.101)",
    fill: "#fff",
    opacity: 0.53
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23481",
    "data-name": "Group 23481",
    transform: "translate(1107.379 115.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M4210.337,1848.1l11.786,24.206-3.077,8.148-5.846-.943.61-5.31a4.256,4.256,0,0,0-.449-2.445l-7.856-15.181,3.015-8.378A.987.987,0,0,1,4210.337,1848.1Z",
    transform: "translate(-3782.327 -1255.101)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M3907.446,1618.59s-3.331,1.415-3.944,3.04c-.492,1.3-4.175,1.472-4.539,4.036a3.156,3.156,0,0,1-2.821,2.587c-3.762.5-9.56,2.209-10.487,7.912-.708,4.353,1.833,6,4.5,6.575a3.332,3.332,0,0,1,2.865,3.81c-.38,1.656.187,3.571,3.473,5.085,7.365,3.393,14.72-8.038,14.72-8.038l1.507-19.959Z",
    transform: "translate(-3491.8 -1047.215)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4011",
    "data-name": "Path 4011",
    d: "M3718.369,3124.232l-.477,3.918a1.619,1.619,0,0,1-1.419,1.416,25.064,25.064,0,0,1-5.244.082,1.386,1.386,0,0,1-1.164-1.8,14.269,14.269,0,0,1,2.628-5.119h4.346A1.339,1.339,0,0,1,3718.369,3124.232Z",
    transform: "translate(-3332.417 -2412.945)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4012",
    "data-name": "Path 4012",
    d: "M4088.124,2640.277l.733,4.315s-2.457,24.883-2.894,34.837a7.8,7.8,0,0,0,1.154,4.433l4.272,6.937-10.856-6.406-.216-1.325,1.777-2.443-2.328-27.876a8.554,8.554,0,0,1,.973-4.73l2.246-4.219Z",
    transform: "translate(-3668.131 -1974.886)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M4089.4,3098.587h-3.465a2.085,2.085,0,0,1-1.655-.812c-1.08-1.4-3.318-4.141-4.388-4.213-1.44-.1-1.256,5.025-1.256,5.025h-.807l-1.023-6.363a3.767,3.767,0,0,1,1.977-3.937h0a5.324,5.324,0,0,0,2.115,3.512c1.785,1.077,7.265,4.935,7.265,4.935a4.953,4.953,0,0,1,1.408.037A.916.916,0,0,1,4089.4,3098.587Z",
    transform: "translate(-3665.425 -2381.67)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M3752.558,2644.855s-14.392,27.3-16.679,33.532a59.863,59.863,0,0,0-3.12,11.925c-.048.769-1,1.507-3.643,1.507a2.531,2.531,0,0,1-2.354-1.074,1.537,1.537,0,0,1-.058-1.49c.833-1.685,3.474-7.069,4.453-9.511,1.168-2.916,3.681-16.129,5.059-20.723s2.936-9.577,8.938-14.168C3745.153,2644.855,3749.272,2640.82,3752.558,2644.855Z",
    transform: "translate(-3347.434 -1977.414)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M4046.271,1857.627c3.712-15.731-6.265-24.051-6.265-24.051,4.1-3.933,10.794-6.661,14.546-7.973a5.118,5.118,0,0,1,5.075.991c2.963,2.614,7.637,7.48,6.791,11.563-.717,3.46-7.252,20.726-7.252,20.726A14.357,14.357,0,0,1,4046.271,1857.627Z",
    transform: "translate(-3632.057 -1234.918)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M3932.572,2184.237c1.511-4.551,8.231-7.788,8.231-7.788a14.358,14.358,0,0,0,12.895,1.256,25.86,25.86,0,0,1,.42,9.993c-.935,4.813-6.8,35.748-6.8,35.748-9.246,1.873-23.465-1.885-23.465-1.885C3929.738,2211.105,3931.061,2188.788,3932.572,2184.237Z",
    transform: "translate(-3526.588 -1553.74)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M4124.668,1693.024l-3.018,13.557c-.289,1.194.8,1,2.007.771,1.977-.373,4.526-1.14,5.377-2.679a1.454,1.454,0,0,0,.154-.511l1.3-9.4a1.689,1.689,0,0,0-.988-1.775l-2.5-1.11A1.689,1.689,0,0,0,4124.668,1693.024Z",
    transform: "translate(-3706.144 -1113.626)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M4130.524,1579.648s3.844.53,7.531,4.888,2.553,7.132.436,8.04-5.351,1.2-9.7-1.083S4125.572,1579.125,4130.524,1579.648Z",
    transform: "translate(-3710.217 -1011.839)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M4073.285,1546.013s-4.565-6.6,1.882-8.423l1.809.655s1.287-4.684-3.128-5.569-10.291,3.9-10.539,9.6.075,4.934,3.508,6.7,4.4,1.133,4.4,1.133a9.011,9.011,0,0,1-.371-3.5c.274-1.421,2.092-.283,2.092-.283Z",
    transform: "translate(-3653.156 -969.111)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M4137.316,1669.387s-2.327-3.406-3.682-1.437,2.361,3.089,3.779,3.394Z",
    transform: "translate(-3716.804 -1091.477)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23423",
    "data-name": "Group 23423",
    transform: "translate(416.619 606.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M4135.116,2186.455h.049l21.3-.023a.943.943,0,1,0,0-1.887l-21.3.023a.943.943,0,0,0-.047,1.886Z",
    transform: "translate(-4134.211 -2167.318)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M4298.028,1997.331h-17.74a3.384,3.384,0,0,0-3.058,1.918l-8.2,17.207h22.046a2.054,2.054,0,0,0,1.911-1.286l6.36-15.922A1.4,1.4,0,0,0,4298.028,1997.331Z",
    transform: "translate(-4256.623 -1997.331)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1526",
    "data-name": "Ellipse 1526",
    cx: 2.25,
    cy: 1.396,
    rx: 2.25,
    ry: 1.396,
    transform: "translate(28.208 10.946) rotate(-71.758)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4023",
    "data-name": "Path 4023",
    d: "M3990.479,1910.266c-3.235,3.5-6.962,18.653-4.763,21.085,1.962,2.851,8.431,6.6,14.458,6.392l8.893-.313c-3.876-3.838-6.485-4.755-9.451-1.871-2.468-.953-5.763-4.867-7.93-6.589a2.246,2.246,0,0,1-.569-2.828c1.572-2.889,3.566-5.872,4.134-8.714C3995.277,1914.12,3992.7,1910.427,3990.479,1910.266Z",
    transform: "translate(-3582.161 -1312.051)",
    fill: "#f8ac72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23482",
    "data-name": "Group 23482",
    transform: "translate(1570.852 667.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4024",
    "data-name": "Path 4024",
    d: "M503.729,1927.266s0,18.5-8.111,16.992c-4.955-.922-7.89-20.851-7.89-20.851s5.127-11.42,5.7-7.682C497.591,1942.9,500.691,1922.1,503.729,1927.266Z",
    transform: "translate(-444.632 -1882.752)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4025",
    "data-name": "Path 4025",
    d: "M507.018,3129.43s-.612,3.467-.913,6.9a2.365,2.365,0,0,0,2.262,2.562c4.57.19,14.347.561,17.855.4a.769.769,0,0,0,.677-1.054h0a1.722,1.722,0,0,0-.881-.928l-16.149-7.422Z",
    transform: "translate(-469.705 -2975.105)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4026",
    "data-name": "Path 4026",
    d: "M657.136,3103.439l.492,4.147s2.829,1.317,4.761-.166l-1.172-4.622Z",
    transform: "translate(-620.324 -2951.152)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4027",
    "data-name": "Path 4027",
    d: "M673.344,2333.669c-.213,1.083-1.141,54.045,4.52,77.778a.806.806,0,0,1-.473.937,14.027,14.027,0,0,1-4.61.937,1.387,1.387,0,0,1-1.376-1c-1.618-5.507-9.372-33.1-10.384-59.452-1.13-29.45,0-1,0-1l.663-18.2Z",
    transform: "translate(-636.163 -2259.349)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4028",
    "data-name": "Path 4028",
    d: "M826.666,3147.421a24.943,24.943,0,0,0-1.919,6.4,1.442,1.442,0,0,0,1.269,1.728c1.509.148,3.833.339,5.693.327a1.438,1.438,0,0,0,1.424-1.6,12.134,12.134,0,0,0-2.832-6.654Z",
    transform: "translate(-807.93 -2991.288)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4029",
    "data-name": "Path 4029",
    d: "M852.566,3092.187l1.15,6.272a4.056,4.056,0,0,0,3.386.232l-.549-6.748Z",
    transform: "translate(-834.686 -2941.387)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4030",
    "data-name": "Path 4030",
    d: "M702.828,2323.631c-4.63,27.943,1,69.063,2.9,77.112a1.255,1.255,0,0,0,1.013.953,8.424,8.424,0,0,0,3.622-.145,1.15,1.15,0,0,0,.827-1.059c.255-6.507-.2-46.452,4.11-62.239a3.588,3.588,0,0,1,1.383-1.979l8.374-5.953.642-9.622Z",
    transform: "translate(-688.054 -2247.686)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23425",
    "data-name": "Group 23425",
    transform: "translate(13.045 23.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4031",
    "data-name": "Path 4031",
    d: "M586.1,1830.2a78.222,78.222,0,0,0-29.7,2.588c-4.136,24.133-.723,51.97-.723,51.97,10.742,2.817,22.86-1.722,22.86-1.722,1.785-10.087,9.225-33.38,9.225-33.38,3.39-.421,6.571,1.292,5.839-3.414S588.227,1830.413,586.1,1830.2Z",
    transform: "translate(-554.356 -1829.805)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4032",
    "data-name": "Path 4032",
    d: "M892.89,1872.914l-5.322-13.436s-12.961,8.806-15.092,19.971a30.672,30.672,0,0,1,11.267,3.02C884.7,1877.2,892.89,1872.914,892.89,1872.914Z",
    transform: "translate(-872.476 -1832.836)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M761.5,2064.221s-14.551,8.224-19.461,1.2a5.519,5.519,0,0,1-1.012-4.289,30.669,30.669,0,0,0-11.267-3.02,15.411,15.411,0,0,0,1.675,10.564c8.6,15.733,31.991-.869,31.991-.869Z",
    transform: "translate(-728.631 -2011.501)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23426",
    "data-name": "Group 23426",
    transform: "translate(32.271 37.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M504.736,2012.8l4.774-16.672a.486.486,0,0,1,.411-.35c.865-.1,3.371-.384,6.265-.629a71.085,71.085,0,0,1,9.953-.331.488.488,0,0,1,.4.7c-1.376,2.783-7.034,14.1-9.867,17.811a.489.489,0,0,1-.394.193l-11.077-.1A.488.488,0,0,1,504.736,2012.8Z",
    transform: "translate(-501.471 -1992.135)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M650.073,2071.093s-1.106-4.549-.66-6.163,1.311-3.689,4.193-3.228a42.2,42.2,0,0,1,6.282,1.675,1.65,1.65,0,0,1-2.362,1.424l1.358,1.051s-.194,1.683-2.044.784l1.263,1.394a1.472,1.472,0,0,1-2.156.5C654.586,2067.639,653.933,2071.641,650.073,2071.093Z",
    transform: "translate(-649.307 -2052.304)",
    fill: "#eb9e64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M489.545,1980.562s3.354-3.266,3.833-4.871.849-3.822-1.838-4.962a42.181,42.181,0,0,0-6.212-1.917,1.65,1.65,0,0,0,1.245,2.461l-1.709.169s-.73,1.529,1.316,1.75l-1.811.51a1.472,1.472,0,0,0,1.563,1.565C487.557,1975.239,485.984,1978.976,489.545,1980.562Z",
    transform: "translate(-466.553 -1968.812)",
    fill: "#eb9e64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M683.868,1728.342l-4.415,12.768a.46.46,0,0,0,.21.554,10.378,10.378,0,0,0,10.765-.724,2.166,2.166,0,0,0,1-1.547l1.43-11.051Z",
    transform: "translate(-653.031 -1714.885)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23427",
    "data-name": "Group 23427",
    transform: "translate(24.768 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M651.648,1662.065s-1.427,10.235-4.092,12.856-7.377-1.118-9.87-6.62l2.811-10.131Z",
    transform: "translate(-632.396 -1651.768)",
    fill: "#f8ac72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M601.942,1607.245a.376.376,0,0,0,.456-.35,9.816,9.816,0,0,1,.588-3.11s-.379-.963,2.558.25,7.341,2.986,9.668,1.425c2.269-1.523,4.042-8.2-2.178-6.361a.376.376,0,0,1-.485-.346c-.03-1.065-.384-3.485-2.925-4.013a3.557,3.557,0,0,0-3.989,1.355.374.374,0,0,1-.583.05,4.338,4.338,0,0,0-5.487-1.058c-2.17,1.234-2.38,2.67-2.254,3.538a.375.375,0,0,1-.5.41,2.257,2.257,0,0,0-2.8,1.152c-1.293,2.009.99,3.4,1.669,3.76a.377.377,0,0,1,.2.292c.1.966.686,5.164,3.041,7.325a.379.379,0,0,0,.616-.173l1.23-4.041a.378.378,0,0,1,.44-.26Z",
    transform: "translate(-593.626 -1594.495)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M748.523,1704.024s-1.406-3.943-2.781-2.476.823,4.163,2.607,4.537Z",
    transform: "translate(-740.092 -1690.49)",
    fill: "#f8ac72"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleLoginArt);
export default __webpack_public_path__ + "static/media/people_login-art.dfc36170f360614cc57a8d4ab3fed36f.svg";
export { ForwardRef as ReactComponent };